if (!customElements.get('sb-sticky-atc')) {
  customElements.define('sb-sticky-atc', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-sticky-notify-mode')) {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const goToSignup = () => {
          const box = document.querySelector('[data-sb-bis].sb-bis--wp40');
          if (!box) return;
          box.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const field = box.querySelector('[data-sb-bis-email]');
          if (field) setTimeout(() => field.focus(), 400);
        };
        this.querySelector('[data-sticky-submit]').addEventListener('click', goToSignup, options);
        this.querySelector('[data-sticky-options]').addEventListener('click', goToSignup, options);
        this.syncNotify = this.syncNotify.bind(this);
        window.addEventListener('scroll', this.syncNotify, { ...options, passive: true });
        window.addEventListener('resize', this.syncNotify, options);
        this.overlayObserver = new MutationObserver(this.syncNotify);
        this.overlayObserver.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
        this.syncNotify();
        return;
      }
      this.variants = JSON.parse(this.querySelector('[data-sticky-variants]').textContent);
      this.button = this.querySelector('[data-sticky-submit]');
      this.sync = this.sync.bind(this);
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.button.addEventListener('click', () => {
        this.sync();
        if (!this.form || this.button.disabled) return;
        this.form.requestSubmit(this.primaryButton);
        this.sync();
      }, options);
      this.querySelector('[data-sticky-options]').addEventListener('click', () => {
        this.form?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, options);
      document.addEventListener('change', this.sync, options);
      document.addEventListener('input', this.sync, options);
      document.addEventListener('variant:change', this.sync, options);
      window.addEventListener('scroll', this.sync, { ...options, passive: true });
      window.addEventListener('resize', this.sync, options);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.sync);
      }
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.sync();
      });
      this.observer.observe(document.body, { subtree:true, childList:true, attributes:true, attributeFilter:['disabled','aria-disabled','class','open','hidden','value'] });
      this.overlayObserver = new MutationObserver(this.sync);
      this.overlayObserver.observe(document.body, { attributes:true, attributeFilter:['class','style'] });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.overlayObserver?.disconnect();
      this.unsubscribe?.();
      document.documentElement.style.removeProperty('--sb-sticky-height');
    }
    syncNotify() {
      const box = document.querySelector('[data-sb-bis].sb-bis--wp40');
      if (!box) { this.hidden = true; return; }
      const rect = box.getBoundingClientRect();
      const visible = rect.top < window.innerHeight && rect.bottom > 0;
      const overlay = document.querySelector('#monster-cart-wrapper.mu_openned, cart-drawer.active, cart-notification.active, dialog[open], details-modal details[open], modal-dialog[open], .menu-drawer-container[open]');
      const hide = visible || !!overlay || document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile');
      if (this.hidden !== hide) this.hidden = hide;
      document.documentElement.style.setProperty('--sb-sticky-height', hide ? '0px' : this.offsetHeight + 'px');
    }
    sync() {
      const variants = this.variants;
      this.form = [...document.querySelectorAll('main form[action*="/cart/add"]')].find(form => variants.some(v => String(v.id) === form.querySelector('[name="id"]')?.value));
      this.primaryButton = this.form?.querySelector('[name="add"], button[type="submit"]');
      if (!this.form || !this.primaryButton) { this.hidden = true; return; }
      const variant = variants.find(v => String(v.id) === this.form.querySelector('[name="id"]').value);
      const quantity = this.form.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"][form="' + this.form.id + '"]');
      const busy = this.primaryButton.classList.contains('loading');
      this.button.disabled = !variant?.available || this.primaryButton.disabled || this.primaryButton.getAttribute('aria-disabled') === 'true';
      const label = busy ? 'Adding…' : !variant?.available ? 'Sold out' : 'Add to cart';
      if (this.button.textContent !== label) this.button.textContent = label;
      const selection = (variant?.title === 'Default Title' ? '' : variant?.title + ' · ') + 'Qty ' + (quantity?.value || '1');
      const selectionNode = this.querySelector('[data-sticky-selection]');
      if (selectionNode.textContent !== selection) selectionNode.textContent = selection;
      const price = this.querySelector('[data-sticky-price]');
      if (variant && price.textContent !== variant.price) price.textContent = variant.price;
      const error = this.form.closest('product-form')?.querySelector('.product-form__error-message')?.textContent?.trim() || '';
      const errorNode = this.querySelector('[data-sticky-error]');
      if (errorNode.textContent !== error) errorNode.textContent = error;
      if (errorNode.hidden !== !error) errorNode.hidden = !error;
      const rect = this.primaryButton.getBoundingClientRect();
      const visible = rect.top < window.innerHeight && rect.bottom > 0;
      const overlay = document.querySelector('#monster-cart-wrapper.mu_openned, cart-drawer.active, cart-notification.active, dialog[open], details-modal details[open], modal-dialog[open], .menu-drawer-container[open]');
      const hide = visible || !!overlay || document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile');
      if (this.hidden !== hide) this.hidden = hide;
      document.documentElement.style.setProperty('--sb-sticky-height', hide ? '0px' : this.offsetHeight + 'px');
    }
  });
}
